import * as React from 'react';
import { type User } from '@bliks-io/contracts';
import { UserCard, toUserCardProps } from '@bliks-io/ui';

interface PersonSuccessorItemProps {
  user: User;
  variant?: 'default' | 'outline' | 'muted';
}

/**
 * PersonSuccessorItem Component
 *
 * Displays a person successor using the v2 UserCard component.
 * Shows avatar, name, role, and department badge.
 * UserCard self-decorates the lifecycle (deleted gray, status suffix).
 * Note: UserCard already wraps itself in an Item component.
 */
export const PersonSuccessorItem = React.forwardRef<HTMLDivElement, PersonSuccessorItemProps>(
  ({ user, variant = 'outline' }, ref) => {
    return (
      <UserCard
        ref={ref}
        user={toUserCardProps(user)}
        variant="with-role"
        itemVariant={variant}
        size="default"
        className="pr-8"
      />
    );
  }
);

PersonSuccessorItem.displayName = 'PersonSuccessorItem';
